var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20474_196023)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_20474_196023)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20474_196023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5729 16.2113C16.931 15.1492 17.8044 13.4952 17.8044 11.6381C17.8044 8.43304 15.2146 5.8403 12.0095 5.83594C8.80017 5.83159 6.19727 8.43014 6.19727 11.6381C6.19727 13.4546 7.03153 15.0752 8.33878 16.1387C8.38956 16.1794 8.46356 16.1707 8.50419 16.1199L9.07584 15.3872C9.11501 15.3378 9.10631 15.2667 9.05843 15.2261C8.9409 15.1304 8.82773 15.0274 8.71892 14.9185C8.2947 14.4958 7.95667 13.9947 7.72361 13.443C7.47986 12.8728 7.35798 12.2649 7.35798 11.6381C7.35798 11.0113 7.47986 10.4034 7.72215 9.8317C7.95575 9.27891 8.2909 8.78271 8.71747 8.35614C9.14403 7.92958 9.64023 7.59443 10.193 7.36083C10.7661 7.11853 11.3741 6.99666 12.0008 6.99666C12.6276 6.99666 13.2355 7.11853 13.8072 7.36083C14.36 7.59443 14.8562 7.92958 15.2828 8.35614C15.7093 8.78271 16.0445 9.27891 16.2781 9.8317C16.5204 10.4034 16.6422 11.0113 16.6422 11.6381C16.6422 12.2649 16.5204 12.8728 16.2781 13.4444C16.045 13.9961 15.707 14.4972 15.2828 14.92C15.1478 15.0549 15.0056 15.1811 14.8576 15.2972L14.2671 14.5413C14.2538 14.524 14.2358 14.5109 14.2153 14.5033C14.1948 14.4958 14.1725 14.4942 14.1512 14.4988C14.1298 14.5033 14.1101 14.5138 14.0945 14.529C14.0788 14.5443 14.0677 14.5636 14.0626 14.5848L13.488 16.9382C13.4706 17.0107 13.5257 17.0818 13.5997 17.0818L16.0227 17.0934C16.1199 17.0934 16.1751 16.9817 16.1141 16.9063L15.5729 16.2113Z",
    fill: "black",
    fillOpacity: 0.85
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20474_196023",
    x: 0.5,
    y: 0,
    width: 24,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20474_196023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20474_196023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_20474_196023",
    x: 0.5,
    y: 0,
    width: 24,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20474_196023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20474_196023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20474_196023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(5.5 4.96484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownTrigger);
export default __webpack_public_path__ + "static/media/dropdown-trigger.6658346d2fc1923a6fec1db2df110701.svg";
export { ForwardRef as ReactComponent };